/*=========================================================================================
  File Name: getters.js
  Description: Vuex Store - getters
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

// added so later we can keep breakpoint in sync automatically using this config file
// import tailwindConfig from "../../tailwind.config.js"

import _ from 'lodash';

const getters = {

	// COMPONENT
		// vx-autosuggest
	// starredPages: state => state.navbarSearchAndPinList.data.filter((page) => page.highlightAction),
  windowBreakPoint: state => {

    // This should be same as tailwind. So, it stays in sync with tailwind utility classes
    if (state.windowWidth >= 1200) return "xl"
    else if (state.windowWidth >= 992) return "lg"
    else if (state.windowWidth >= 768) return "md"
    else if (state.windowWidth >= 576) return "sm"
    else return "xs"
  },

  scrollbarTag: state => {
    return state.is_touch_device ? 'div' : 'VuePerfectScrollbar'
  },

  /**
   * Custom
   */

  isUserLoggedIn: state => {
    return state.authUser !== undefined && state.authUser !== null
        ? true
        : false
  },
  authUser: state => {
      if (state.authUser !== null && state.authUser !== undefined) {
          return state.authUser
      }
  },
  userRole: state => {
      return  state.userRole && state.userRole
  },
  userRoleName: state => {
      if (state.authUser !== null && state.authUser !== undefined) {
          let role = state.userRole
          if (!role) return ''
          role = role.split('_')
          if (role && role.length > 1)
              return `${_.capitalize(role[0])} ${_.capitalize(role[1])}`
          if (role && role.length === 1) return `${_.capitalize(role[0])}`
      }
  },
  meliAccount: state => {
      if (state.authUser !== undefined && state.authUser !== null) {
          return state.authUser
      }
  },
  cdSurAccount: state => {
      if (state.authUser !== undefined && state.authUser !== null) {
          const { glovo_account } = state.authUser
          return glovo_account ? glovo_account : ''
      }
      return null
  },
  meliAccountStatus: state => {
      if (state.authUser !== undefined && state.authUser !== null) {
          
        // To-Do: comaprar con fecha expiracion
        const isActive = state.authUser.meli_user_id 
            && state.authUser.meli_access_token 
            && state.authUser.meli_expires_in ;

       if(isActive) {
            return {
                name: 'Activo',
                color: 'success'
            }
       } else {
            return {
                name: 'Por Conectar',
                color: 'danger'
            }
        }
      }
  },
  cdSurAccountStatus: state => {
      if (state.authUser !== undefined && state.authUser !== null) {

        const isActive = state.authUser.cdsur_user 
            && state.authUser.cdsur_idcliente ;
            
        if(isActive) {
            return {
                name: 'Activo',
                color: 'success'
            }
        } else {
            return {
                name: 'Inactivo',
                color: 'danger'
            }
        }
      }
  }

}

export default getters
